<template>
  <div class="chart-widget-component">
    <div class="btn-hover-times">
      <b-button
        class="btn__icon btn__icon--primary px-1 py-0"
        @click="$emit('hideItemLayout')"
      >
        <i
          class="fal fa-times"
          aria-hidden="true"
        />
      </b-button>
    </div>
    <b-container v-if="preloader">
      <div class="d-flex flex-column align-items-center">
        <div class="preloader preloader-header-box align-self-start" />
        <div class="preloader preloader-form-box align-self-start" />
        <div class="preloader preloader-form-box align-self-start" />
        <div class="preloader preloader-form-box align-self-start" />
        <div class="preloader preloader-chart-box" />
      </div>
    </b-container>
    <b-container v-if="!preloader">
      <chart-widget-case-type
        v-if="item.subType === 'caseType'"
        :item="item"
      />
      <chart-widget-case-priority
        v-if="item.subType === 'casePriority'"
        :item="item"
        :case-types="caseTypes"
      />
      <chart-widget-case-situation
        v-if="item.subType === 'caseSituation'"
        :item="item"
        :case-types="caseTypes"
      />
      <chart-widget-case-delayed
        v-if="item.subType === 'caseDelayed'"
        ref="caseDelayedChartContainer"
        :update="update"
        :item="item"
        :case-types="caseTypes"
        @toggleWidgetConfigurationSidepanel="toggleWidgetConfigurationSidepanel"
      />
    </b-container>
  </div>
</template>

<script>
import ChartWidgetCaseType from '@/modules/dashboardModule/widgets/chartWidget/ChartWidgetCaseType'
import ChartWidgetCasePriority from '@/modules/dashboardModule/widgets/chartWidget/ChartWidgetCasePriority'
import ChartWidgetCaseSituation from '@/modules/dashboardModule/widgets/chartWidget/ChartWidgetCaseSituation'
import ChartWidgetCaseDelayed from '@/modules/dashboardModule/widgets/chartWidget/ChartWidgetCaseDelayed'
import { HelperUtils } from '@/shared/util/helper-utils'
import { ModuleOperation } from '@/api/operations/models/module-operation'
import { commonCaseTypeService } from '@/api/services/common/case-type/common-case-type.service'

export default {
    name: 'ChartWidget',
    components: { ChartWidgetCaseSituation, ChartWidgetCasePriority, ChartWidgetCaseType, ChartWidgetCaseDelayed },
    props: {
        item: { type: Object },
        update: { type: Boolean }
    },
    data() {
        return {
            caseTypes: [],
            preloader: false
        }
    },
    async created() {
        if (HelperUtils.hasModuleAccess(ModuleOperation.DIAGNOSE)) {
            await this._getCaseTypes()
        }
    },
    methods: {
        async _getCaseTypes() {
            const response = await this.$_toCallUnique(commonCaseTypeService.getCaseTypes())
            this.caseTypes = response ?? []
        },
        toggleWidgetConfigurationSidepanel() {
            this.$emit('toggleWidgetConfigurationSidepanel')
        }
    }
}
</script>

<style lang="scss">
.chart-widget-blank {
    opacity: .7;
}
.chart-widget-blank span {
    font-size: font-size(very-normal);
    line-height: 20px;
    max-width: 190px;
    font-style: italic;
}
.chart-widget-component .preloader-header-box {
    width: 160px;
    height: 50px;
    margin-top: 10px;
    margin-bottom: 15px
}
.chart-widget-component .preloader-form-box {
    width: 100%;
    height: 25px;
    margin-top: 5px;
}
.chart-widget-component .preloader-chart-box {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-top: 25px;
}
</style>
